/** @format */

import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import swal from "sweetalert";
import Pagination from "./pagination";
import {
  addClasses,
  addTeachers,
  filterTeachers,
  deleteData,
  createPages
} from "../redux/action/actions";

export class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      std: "",
      section: "",
      teacherName: "",
      subjectName: "",
      sectionSelected: "",
      classSelected: "",
      filterSelected: "all",
      tempData: [],
      page: 0,
      perPage: 0,
      isLoaded: false
    };
    this.handleDelete = this.handleDelete.bind(this);
  }
  componentDidMount = async () => {
    const { teachers, createPages } = this.props;
    this.setState({
      tempData: [...teachers]
    });
    await createPages();
    const { isLoaded, perPage, pageDup } = this.props;
    this.setState({
      isLoaded: isLoaded,
      perPage,
      page: pageDup
    });
  };

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };
  handleChange1 = e => {
    this.setState(
      {
        [e.target.name]: e.target.value
      },
      async () => {
        const { filterTeachers, createPages } = this.props;
        const { filterSelected } = this.state;
        await filterTeachers(filterSelected);
        createPages();
        const { temp } = this.props;
        this.setState({
          tempData: [...temp]
        });
      }
    );
  };
  handleDelete = async id => {
    const { deleteData } = this.props;
    await deleteData(id);
    const { temp } = this.props;
    this.setState({
      tempData: [...temp]
    });
    swal({
      title: "Deleted Successfully!",
      icon: "success"
    });
  };
  addClass = () => {
    const { std, section } = this.state;
    const { addClasses } = this.props;
    addClasses({ std, section });
    this.setState({
      std: "",
      section: ""
    });
    swal({
      title: "Added Successfully!",
      icon: "success"
    });
  };

  addTeacher = async () => {
    const {
      classSelected,
      sectionSelected,
      teacherName,
      subjectName,
      filterSelected
    } = this.state;
    const { addTeachers, filterTeachers } = this.props;
    await addTeachers({
      classSelected,
      sectionSelected,
      teacherName,
      subjectName
    });
    swal({
      title: "Added Successfully!",
      icon: "success"
    });
    filterTeachers(filterSelected);
    const { temp } = this.props;
    this.setState({
      tempData: [...temp],
      classSelected: "",
      subjectName: "",
      teacherName: "",
      sectionSelected: ""
    });
  };

  render() {
    const {
      classSelected,
      tempData,
      page,
      perPage,
      teacherName,
      subjectName,
      sectionSelected,
      std,
      section
    } = this.state;
    const { pageDup } = this.props;
    const { classes } = this.props;
    let teachersData = [...tempData];
    let classOption = classes.map(ele => {
      return (
        <option key={ele.std} value={ele.std}>
          {ele.std}
        </option>
      );
    });
    let sectionOption = [];
    classes.map(ele => {
      if (ele.std == classSelected) {
        sectionOption = ele.sections.map(ele => {
          return (
            <option value={ele} key={ele}>
              Section - {ele}
            </option>
          );
        });
      }
    });

    return (
      <>
        <div className="row d-flex justify-content-center">
          <div className="col-sm-11 col-md-3 col-lg-3 ">
            <div className="form-group">
              <h3 className=" text-primary">Filter By Class</h3>
              <label htmlFor="#filter">Select Class</label>
              <select
                id="filter"
                name="filterSelected"
                className="form-control"
                onChange={this.handleChange1}
              >
                <option value="all">All</option>
                {classOption.map(ele => {
                  return ele;
                })}
              </select>
            </div>
          </div>
          <div className="col-sm-11 col-md-3 col-lg-3 mx-1">
            <div className="form-group">
              <h3 className="text-primary">Add Teacher / subjectName</h3>
              <label htmlFor="#teacherName">Add Teacher Name </label>
              <input
                type="text"
                id="teacherName"
                name="teacherName"
                className="form-control"
                placeholder="Enter Teacher's Name"
                onChange={this.handleChange}
                value={teacherName}
              />
              <label htmlFor="#subjectName">Add subjectName </label>
              <input
                type="text"
                id="subjectName"
                name="subjectName"
                className="form-control"
                placeholder="Enter subjectName"
                onChange={this.handleChange}
                value={subjectName}
              />
              <div className="form-group">
                <label htmlFor="#classSelected">Class</label>
                <select
                  id="classSelected"
                  name="classSelected"
                  className="form-control"
                  onChange={this.handleChange}
                  value={classSelected}
                >
                  <option value="">Choose</option>

                  {classOption.map(ele => {
                    return ele;
                  })}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="#sectionSelected">Section</label>
                <select
                  id="sectionSelected"
                  name="sectionSelected"
                  className="form-control"
                  onChange={this.handleChange}
                  value={sectionSelected}
                >
                  <option value="">Choose</option>

                  {sectionOption.map(ele => {
                    return ele;
                  })}
                </select>
              </div>
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={this.addTeacher}
              >
                Add Teacher/subjectName
              </button>
            </div>
          </div>
          <div className="col-sm-11 col-md-3 col-lg-3">
            <div className="form-group">
              <h3 className="text-primary">Add Class / Section</h3>

              <label htmlFor="#std">Add class </label>
              <input
                type="text"
                id="std"
                name="std"
                placeholder="Example - Class 4"
                className="form-control"
                onChange={this.handleChange}
                value={std}
              />
              <label htmlFor="#section">Add Section </label>
              <input
                type="text"
                id="section"
                name="section"
                placeholder="Example - A"
                className="form-control"
                onChange={this.handleChange}
                value={section}
              />
            </div>
            <button
              type="button"
              className="btn btn-primary py-2 w-100"
              onClick={this.addClass}
            >
              Add Class/Section
            </button>
          </div>
        </div>
        <div className="table-responsive-lg">
          <table className="table">
            <thead>
              <tr>
                <th scope="col" className="text-center">
                  #
                </th>
                <th scope="col" className="text-center">
                  Name
                </th>
                <th scope="col" className="text-center">
                  Class
                </th>
                <th scope="col" className="text-center">
                  Section
                </th>
                <th scope="col" className="text-center">
                  subjectName
                </th>
                <th scope="col" className="text-center">
                  Edit
                </th>
                <th scope="col" className="text-center">
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              {teachersData
                .filter(
                  (a, i) =>
                    i >= perPage * (pageDup - 1) && i < perPage * pageDup
                )
                .map(ele => {
                  return (
                    <tr key={ele.id}>
                      <td className="text-center">{ele.id}</td>
                      <td className="text-center">{ele.teacherName}</td>
                      <td className="text-center">{ele.classSelected}</td>
                      <td className="text-center">{ele.sectionSelected}</td>
                      <td className="text-center">{ele.subjectName}</td>
                      <td className="text-center">
                        <Link
                          to={`/home/edit/${ele.id}`}
                          className="btn btn-primary"
                        >
                          Edit
                        </Link>
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-danger"
                          onClick={() => this.handleDelete(ele.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {}
          {this.state.isLoaded && (
            <div className="row justify-content-center">
              <Pagination />
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    teachers: state.teachersReducers.teachers,
    classes: state.teachersReducers.classes,
    temp: state.teachersReducers.temp,
    pageDup: state.teachersReducers.page,
    perPage: state.teachersReducers.perPage,
    isLoaded: state.teachersReducers.isLoaded
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addClasses: payload => dispatch(addClasses(payload)),
    addTeachers: payload => dispatch(addTeachers(payload)),
    filterTeachers: payload => dispatch(filterTeachers(payload)),
    deleteData: payload => dispatch(deleteData(payload)),
    createPages: () => dispatch(createPages())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
